import {getErrorHandling} from "../../helpers/errors";

export function getDefaultFailureActionReducer(state, action) {
	return {
		...state,
		isLoading: action.isLoading,
		...getErrorHandling(action, state),
	};
}
